import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError, delay } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  // Never attach our auth/session headers to third-party requests (e.g. the zip lookup API).
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const publicAuthPaths = [
    '/auth/login',
    '/auth/verify-otp',
    '/auth/resolve-challenge',
    '/auth/accept-invite',
    '/auth/invite-details',
  ];
  const isPublicAuth = publicAuthPaths.some(p => req.url.includes(p));
  let cloned = req;
  const token = auth.getToken();
  const clientIp = localStorage.getItem('sl_client_ip') ?? '';
  const clientLocation = localStorage.getItem('sl_client_location') ?? '';

  const headers: Record<string, string> = {};

  if (token && !isPublicAuth) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  if (clientIp) {
    headers['x-client-ip'] = clientIp;
  }
  if (clientLocation) {
    headers['x-client-location'] = clientLocation;
  }

  // Prevent aggressive browser caching on API GET requests so data is always fresh
  if (req.method === 'GET') {
    headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    headers['Pragma'] = 'no-cache';
    headers['Expires'] = '0';
  }

  if (Object.keys(headers).length > 0) {
    cloned = req.clone({
      setHeaders: headers,
    });
  }

  let requestStream = next(cloned);
  if (req.method === 'GET' && req.url.includes('page=')) {
    requestStream = requestStream.pipe(delay(300));
  }

  return requestStream.pipe(
    catchError(err => {
      if (err.status === 401 && !isPublicAuth) {
        auth.logout();
      }
      return throwError(() => err);
    }),
  );
};
